import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  initialValue: boolean = false;
  refreshSitesSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.initialValue);

  constructor(private http: HttpClient) {
  }


  toggleRefreshData() {
    this.refreshSitesSource.next(!this.refreshSitesSource.value)
  }

  getRefreshData(): Observable<boolean> {
    return this.refreshSitesSource.asObservable();
  }

  addAddress(body: any, id: number) {
    return this.http.post(
      `${environment.api.BASE_URL}/adresses/etablissements/${id}`, body
    );
  }

  getAddressesFilter( body: any, version = ""): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}${version}/adresses/search`, body);
  }

  updateAddressSocial(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/adresses/social`, body);
  }

  hideSite(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/adresses/isvisible`, body);
  }

}
